var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPromoTag = function SvgPromoTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 2.18v5.095c0 .58.228 1.135.637 1.544l6.544 6.542a2.18 2.18 0 0 0 3.085 0l5.095-5.094a2.18 2.18 0 0 0 0-3.084L8.817.641A2.16 2.16 0 0 0 7.277 0H2.18A2.183 2.183 0 0 0 0 2.18m3.817.546a1.09 1.09 0 1 1 0 2.182 1.09 1.09 0 0 1 0-2.182"
  })));
};
export default SvgPromoTag;